angular
.module('gc.services', [])
.constant('BASE_URL', 'https://graphcomment.com')
.constant('API_URL', 'https://graphcomment.com/api')
.constant('BO_URL', 'https://graphcomment.com/admin')
.constant('WS_URL', 'wss://local.graphcomment.com/websocket')
.constant('URL_SHORTENER', 'https://local.yak.li')          // YAKLI URL
.constant('RECAPTCHA_PUBLIC_KEY', 'recaptchaPublicKey')
.constant('GRAPHLOGIN_URL', 'graphloginUrl')

.constant('ORANGE_BASE_URL', 'https://local.orange.fr')
.constant('ORANGE_API_URL', 'https://local.orange.fr/api')
.constant('ORANGE_WS_URL', 'wss://local.orange.fr/websocket')
.constant('ORANGE_URL_SHORTENER', 'https://local.orange.fr/yakli')          // YAKLI URL

.constant('DEFAULT_LANGUAGE', 'en')                         // DEFAULT LANGUAGE, if no language found
.constant('APP_LANGUAGES', [
  {value: 'en', label: 'English'},
  {value: 'fr', label: 'Français'},
  {value: 'de', label: 'Deutsch'},
  {value: 'zh', label: '中文'},
  {value: 'es', label: 'Español'},
  {value: 'pt', label: 'Português'},
  {value: 'it', label: 'Italiano'},
  {value: 'cz', label: 'Čeština'},
  {value: 'fa', label: 'فارسی'},
  {value: 'he', label: 'עברית'},
  {value: 'ru', label: 'русский'},
  {value: 'vi', label: 'Tiếng việt'},
  {value: 'uk', label: 'Українська'},
  {value: 'tr', label: 'Türkçe'},
  {value: 'ar', label: 'العربية'},
  {value: 'id', label: 'Bahasa Indonesia'},
  {value: 'hu', label: 'Magyar'},
  {value: 'ca', label: 'Català'},
  {value: 'sv', label: 'Svenska'},
  {value: 'pl', label: 'Polski'},
  {value: 'nb', label: 'Norsk Bokmål'},
  {value: 'ro', label: 'Română'},
]);
